// Maps the 11Labs post-call `termination_reason` string to who ended the call.
// Only two reasons map to a person; every other value (system errors, network
// drops, duration limits) is not attributable to caller or agent and returns
// null so the UI shows nothing rather than guessing.
//
// Observed prod values (3000 recent CallData records, TRK-5741):
//   "Call ended by remote party"                -> caller hung up
//   "end_call tool was called."                 -> agent ended the call
//   "Client disconnected: 1006"                 -> network drop (not a person)
//   "custom_llm generation failed"              -> system error
//   "Conversation has exceeded maximum duration"-> system limit
//   "No user message received ... network error"-> network/timeout
//   "Generating the LLM response took too long."-> system error

export const CALLER_ENDED_TERMINATION_REASON = `Call ended by remote party`
export const AGENT_ENDED_TERMINATION_REASON = `end_call tool was called.`

export type CallEndedBy = 'caller' | 'agent'

export function callEndedBy(terminationReason?: string | null): CallEndedBy | null {
  if (terminationReason === CALLER_ENDED_TERMINATION_REASON) return `caller`
  if (terminationReason === AGENT_ENDED_TERMINATION_REASON) return `agent`
  return null
}

export const CALL_ENDED_BY_LABEL: Record<CallEndedBy, string> = {
  caller: `Caller`,
  agent: `Agent`,
}
